export default __webpack_public_path__ + "static/media/cto-red.cc2c655e.svg";